import {NgModule} from '@angular/core';
import {SharedModule} from './shared.module';
import {MaterialModule} from './material.module';
import {CovercySharedComponentsModule} from './CovercySharedComponents.module';
import {HoldingIsDownCardComponent} from '../dashboard/shared/holding/holding-is-down-card/holding-is-down-card.component';
import {ExportFundraisingsMenuComponent} from '../dashboard/shared/holding/fundraising/export-fundraisings-menu/export-fundraisings-menu.component';
import {ExportDistributionsMenuComponent} from '../dashboard/shared/holding/distribution/distributions-tab/export-distributions-menu/export-distributions-menu.component';

@NgModule({
  declarations: [
    HoldingIsDownCardComponent,
    ExportFundraisingsMenuComponent,
    ExportDistributionsMenuComponent
  ],
  imports: [
    SharedModule,
    MaterialModule,
    CovercySharedComponentsModule
  ],
  exports: [
    HoldingIsDownCardComponent,
    ExportFundraisingsMenuComponent,
    ExportDistributionsMenuComponent
  ]
})
export class GpSharedModule {
}
